import axios from 'axios'
import Vue from 'vue'

const service = axios.create({
  baseURL: '/',
  timeout: 30000
})

// 请求拦截器
service.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data 
    if (res.status==200) {
      return res.data
    }
    Vue.prototype.$message && Vue.prototype.$message.error(res.errMsg || '请求失败')
    return Promise.reject(new Error(res.errMsg || '请求失败'))
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

export default service
